<template>
  <div
    :id="id"
    ref="tableRef"
    class="mt-5 table-report table-report--tabulator"
    :data-test="`${tableName}-data-table`"
  />
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch } from 'vue'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import axios from "axios";
import { useRouter } from 'vue-router'
import { useStore } from "vuex";


export default defineComponent({
  props: {
    dataArrayTable: {
      type: Array,
    },
    paginationSize: {
      type: Number,
      default: 10,
    },
    paginationSizeArray: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    dataArray: {
      type: Array,
    },
    apiUrl: {
      type: String,
    },
    tableName: {
      type: String,
      default: "init"
    },
    routerName:{
      type: String
    },
    apiParams:{
      type: Object
    },
    totalList:{
      type: Number
    },
    methodRequest:{
      type: String
    },
    initSorter:{
      type: Array
    },
    defaultSort:{
      type: Array
    },
    customSort:{
      type: Array,
      default: () => []
    },
    id:{
      type: String,
      default: "tabulator"
    },
    deselect:{
      type: Boolean,
      default: false
    }
  },
  setup(props,{emit}) {
    const tableRef = ref();
    const tabulator = ref();
    // console.log("props ", props.dataArrayTable);
    const router = useRouter()
    const store = useStore();
    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        locale: "th-th",
        langs: {
          "th-th": {
            pagination: {
              page_size: "แสดง",
            },
          },
        },
        // data: props.dataArray,
        ajaxURL: `${process.env.VUE_APP_BASE_API}${props.apiUrl}`, //call api if using api no need to send dataArray
        ajaxConfig: props.methodRequest,
        ajaxParams: props.apiParams,
        // initialSort:props.initSorter, //set initial sort with column name define on table
        ajaxRequestFunc: function(url, config, params) {
          params.length = String(params.length)
          params.start = String(params.start)
          //on load check current sort and custom sort
          if(params.sorters.length > 0){
            for(let item of props.customSort){
              //find has custom column sort
              let customFilter = params.sorters.find(({field}) => field == item.column)
              //if has custom sort then push relate field to sorters
              if(customFilter){
                for(let relate of item.relateColumn){
                  params.sorters.push({field: relate, dir: customFilter.dir})
                }
              }
            }
          }else{
            //set default sort
            params.sorters = props.defaultSort
          }
          return axios.post(url, params).then(res => res.data)
        },
        ajaxResponse: function(url, params, response){
          document.getElementById(props.id).getElementsByClassName("totalList")[0].innerHTML = response.recordsTotal
          emit("foundData",response.data)
          return response; //return the tableData property of a response json object
        },
        rowClick: function(e, row){
          emit("rowClick",row._row.data)
        },
        rowSelectionChanged:function(data, rows){
          //rows - array of row components for the selected rows in order of selection
          //data - array of data objects for the selected rows in order of selection
          emit("rowSelected",data)
        },
        pageLoaded: function(e, row){
          if(window.innerWidth > 1005){
            document.querySelectorAll(".tabulator-col").forEach((col)=>{
              if(col.style.display == 'none'){
                col.style.display = 'inline-block'
                col.setAttribute("hide","true")
              }
              //check cell field name equal to header column and set width
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
                  cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
                }
              })
            })
            document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
              if(cell.style.display == 'none')
                cell.style.display = 'inline-block'
            })
          }
        },
        layout:"fitColumns",
        responsiveLayout:'collapse',
        // pagination: 'local',
        pagination: 'remote',
        ajaxSorting:true,
        paginationDataSent:{
            "page":"start", //change page request parameter to "pageNo"
            "size": "length",
        },
        paginationDataReceived:{
            "last_page":"maxPage", //change last_page parameter name to "max_pages"
        } ,
        headerSort:true,
        paginationSize: props.paginationSize,
        paginationSizeSelector: props.paginationSizeArray,
        cellVertAlign:"middle",
        placeholder:"ไม่มีข้อมูล",
        footerElement:`<span class="mb-1">ทั้งหมด <span class="totalList"></span> รายการ</span>`,
        columns: props.dataArrayTable,
        columnHeaderSortMulti:true,
        renderComplete() {
          feather.replace({
            'stroke-width': 2
          })
        },
        maxHeight: 1000
      })
    }
    const testSort = () =>{
      let ee = tabulator.value.getSorters()
    }
    watch(()=> props.deselect, (val)=>{
      if(val)
        tabulator.value.deselectRow()
    })
    // Redraw table onresize
    const reInitOnResizeWindow = () => {
      //when load
      if(window.innerWidth > 1005){
        document.querySelectorAll(".tabulator-col").forEach((col)=>{
          if(col.style.display == 'none'){
            col.style.display = 'inline-block'
            col.setAttribute("hide","true")
          }
          //check cell field name equal to header column and set width
          document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
            if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
              cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
            }
          })
        })
        document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
          if(cell.style.display == 'none')
            cell.style.display = 'inline-block'
        })
      }

      window.addEventListener("resize", () => {
        tabulator.value.redraw();
        if(window.innerWidth <= 1005){
          document.querySelectorAll(".tabulator-col").forEach((col)=>{
            if(col.hasAttribute('hide')){
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(col.style.display == 'inline-block' && (cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field'))){
                  cell.style.display = 'none'
                  cell.style.removeProperty('height')
                }
              })
            }
            else{//when resize from small to large screen
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(col.style.display == 'none' && (cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field'))){
                  cell.style.display = 'none'
                  cell.style.removeProperty('height')
                }
              })
            }
           })
        }
        else{
          // always display every column
          document.querySelectorAll(".tabulator-col").forEach((col)=>{
            if(col.style.display == 'none'){
              col.style.display = 'inline-block'
              col.setAttribute("hide","true")
            }
          })
          document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
              cell.style.display = 'inline-block'
              cell.style.removeProperty('height')
          })
        }
        feather.replace({
          "stroke-width": 1.5,
        });
      });
    };

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
    })

    return {
      tableRef,
      testSort
    }
  }
})
</script>
<style lang="scss">
#tabulator.tabulator .tabulator-row .tabulator-responsive-collapse{
  display: none;
}
/* .tabulator .tabulator-header .tabulator-headers .tabulator-col, .tabulator .tabulator-row .tabulator-cell{
  display: inline-block !important;
  min-width: 80px;
  width: 200px;
} */
#tabulator.tabulator .tabulator-row .tabulator-responsive-collapse td strong {
  font-weight: 600 !important;
}
.tabulator-cell[tabulator-field=full_name]{
  font-weight: 600;
}
@media only screen and (max-width:1005px){
  #tabulator.tabulator {
    .tabulator-tableHolder {
      // overflow: unset !important;
      .tabulator-table{
        white-space: normal !important;
        width: 100%;
        .tabulator-row .tabulator-responsive-collapse{
          display: block;
        }
      }
    }
  }
}


</style>
